import { useContext } from 'react';
import TileButton from '../components/TileButton.jsx';
import { InteractionContext } from '../../../contexts';

const RsvpToEvent = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <>
      {values.answers.map((answer, i) => (
        <TileButton
          key={`rsvp_button_${i}`}
          buttonText={answer}
          buttonIndex={i}
          onChangeButtonText={handleChange}
        />
      ))}
    </>
  );
};

export default RsvpToEvent;
